import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import * as MetaActions from '../../meta-reducer/logout.reducer';
import { LogoutUser, SetAuthToken, SetCustomerId, SetLoggedIn, SetUserName } from './auth.actions';
export interface AuthStateModel {
  authToken?: string;
  customerId?: string;
  userName?: string;
  loggedIn: boolean;
}

const DEFAULT_STATE: AuthStateModel = {
  loggedIn: false,
  authToken: undefined,
  customerId: undefined,
  userName: undefined,
};

@State<AuthStateModel>({
  name: 'auth',
  defaults: DEFAULT_STATE,
})
@Injectable()
export class AuthStateModule {
  constructor(private readonly store: Store) {}
  @Selector()
  public static loggedIn(state: AuthStateModel): boolean {
    return !!state?.loggedIn;
  }

  @Selector()
  public static customerId(state: AuthStateModel): string {
    return state?.customerId ?? '';
  }

  @Selector()
  public static userName(state: AuthStateModel): string {
    return state?.userName ?? '';
  }

  @Selector()
  public static authToken(state: AuthStateModel): string {
    return state?.authToken ?? '';
  }

  @Action(SetLoggedIn)
  public setLoggedIn(ctx: StateContext<AuthStateModel>, { payload }: SetLoggedIn) {
    const { loggedIn } = payload;
    return ctx.patchState({ loggedIn });
  }

  @Action(SetAuthToken)
  public setAuthToken(ctx: StateContext<AuthStateModel>, { payload }: SetAuthToken) {
    const { authToken } = payload;
    return ctx.patchState({ authToken });
  }

  @Action(SetCustomerId)
  public setCustomerId(ctx: StateContext<AuthStateModel>, { payload }: SetCustomerId) {
    const { customerId } = payload;
    return ctx.patchState({ customerId });
  }

  @Action(SetUserName)
  public setUserName(ctx: StateContext<AuthStateModel>, { payload }: SetUserName) {
    const { userName } = payload;
    return ctx.patchState({ userName });
  }

  @Action(LogoutUser)
  public logoutUser(ctx: StateContext<AuthStateModel>) {
    this.store.dispatch(MetaActions.logoutAction());
    return ctx.setState(DEFAULT_STATE);
  }
}
